import { render, staticRenderFns } from "./DownloadContentButtons.vue?vue&type=template&id=627f818b&scoped=true&"
import script from "./DownloadContentButtons.vue?vue&type=script&lang=js&"
export * from "./DownloadContentButtons.vue?vue&type=script&lang=js&"
import style0 from "./DownloadContentButtons.vue?vue&type=style&index=0&id=627f818b&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627f818b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('627f818b')) {
      api.createRecord('627f818b', component.options)
    } else {
      api.reload('627f818b', component.options)
    }
    module.hot.accept("./DownloadContentButtons.vue?vue&type=template&id=627f818b&scoped=true&", function () {
      api.rerender('627f818b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/contents/DownloadContentButtons.vue"
export default component.exports